import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InboundService {
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(params: any): any {
    return this.http.get(`${environment.apiStock}/InboundNote`, { params });
  }

  filterDefinitionInboundNote() {
    return this.http.get(`${environment.apiStock}/InboundNote/FilterDefinitionInboundNote`);
  }

  saveRecord(data: any) {
    return this.http.post(`${environment.apiStock}/InboundNote/CreateInboundNote`, data);
  }

  getDetails(id: number) {
    return this.http.get(`${environment.apiStock}/InboundNote/InboundNoteDetails/${id}`);
  }

  getInboundNoteDefinition(id: number) {
    return this.http.get(`${environment.apiStock}/InboundNote/InboundNoteDefinition/${id}`);
  }

  getDivsions(organizationId: number) {
    return this.http.get(`${environment.apiStock}/InboundNote/GetDivsions/${organizationId}`);
  }

  getStockholders(divisionId: number) {
    return this.http.get(`${environment.apiStock}/InboundNote/GetStockholders/${divisionId}`);
  }

  getPacks(skuId: number) {
    return this.http.get(`${environment.apiStock}/InboundNote/GetPacks/${skuId}`);
  }

  getSku(organizationId: number) {
    return this.http.get(`${environment.apiStock}/InboundNote/GetSku/${organizationId}`);
  }

  inboundAddList(data: any) {
    return this.http.post(`${environment.apiStock}/InboundNote/InboundAddList`, data);
  }

  importFile(data: any) {
    return this.http.post(`${environment.apiStock}/InboundNote/ImportExcelFile`, data);
  }

  downloadFile() {
    return this.http.get(`${environment.apiStock}/InboundNote/DownloadFile`, { responseType: 'blob' });
  }

  getLotsBySKU(SKUId: number) {
    return this.http.get(`${environment.apiStock}/OutboundNote/GetLotsBySKU/${SKUId}`);
  }

  createQuickASN(data: any) {
    return this.http.post(`${environment.apiStock}/ASN/CreateQuickASN`, data);
  }

  getSupplierByOrg(id: number) {
    return this.http.get(`${environment.apiStock}/InboundNote/GetSupplierByOrg?OrgId=${id}`);
  }

  cancelInboundNote(data: any) {
    return this.http.post(`${environment.apiStock}/InboundNote/CancelInboundNote`, data);
  }
  
}
